// extracted by mini-css-extract-plugin
export default {"imageSlide":"styles_imageSlide__9mdgY","active":"styles_active__IJWlh"};